import useVariableChangeTracker from "./useVariableChangeTracker";
import O from "./O";
import FigureImageExpansionLayout from './FigureImageExpansionLayout';
import G from './Getters';
import { useSelector } from 'react-redux';

import { ExpansionWindowFocusContext, ExpansionTemplateInfo, FigureInteractionContext } from './Contexts';

import { useState, useContext, useMemo, useEffect } from 'react';
import { setData, overrideNodes } from './utils';
import React from 'react';


export default function FigureImageExpansionContainer({

    figurePanelId,
    value,
    onCellInteractionEvent,
    width,
    cellLocation,
}){

  

  let { annotationId, regions } = value;

  let { selectedFigureItems } = useContext(FigureInteractionContext);

  /*let  = useVariableChangeTracker({

    figurePanelId,
    value,
    onCellInteractionEvent,
    width,
    cellLocation, 
  })*/

  useMemo(() => {
    console.log("it changed!");
  },[figurePanelId])

  



  let { nodes, computedDimensions } = useSelector(state => {


    
    let computedDimensions = G.getEvaluatedExpansionNodeDimensions(state,{figurePanelId, cellLocation, regions, value,
      localTemplateId:value?.localTemplateId,
      width,
    });

    let nodes = G.getMicroscopyExpansionNodes(state,{
        figurePanelId,cellLocation,value,
      excludeNodeTypes:["scalebar","regionOutline"]
    })

    return {
      nodes,
      computedDimensions,
    }}); 



  //console.log(nodes);




  

  let selectedNodes = selectedFigureItems?.expansionNodes;


  let rootDim = computedDimensions.root;


  let pixelDimensions = {
    w:width, 
    h:(computedDimensions.root.h / rootDim.w )* width 
  };

  const expansionWindowFocusContext = useMemo(() => (
    { onItemClick:onCellInteractionEvent, 
      onEvent:onCellInteractionEvent, selectedNodes }
  ),[onCellInteractionEvent,selectedNodes])



  const layoutProps = useMemo(() => ({nodeId:"root",
    nodes, 
    computedDimensions, 
    parentPixelDimensions:{w:width,},
    regions:{
      main:annotationId,
      ...regions,
    }
  }),[
    nodes,
    computedDimensions,
    width,
    annotationId,
    regions,
    value
  ])

  return (
    <ExpansionWindowFocusContext.Provider value={expansionWindowFocusContext}>
      <ExpansionTemplateInfo.Provider value={computedDimensions}>
        {true && <FigureImageExpansionLayout {...layoutProps}/>}

      </ExpansionTemplateInfo.Provider>
    </ExpansionWindowFocusContext.Provider>
  )

}

//export default React.memo(FigureImageExpansionContainer);
